var React = require('react');

function ProgressIndicator (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"x":"56","y":"88","width":"208","height":"24","fill":"#D8D8D8","key":1}),React.createElement("circle",{"cx":"36","cy":"100","r":"10.5","stroke":"#404040","strokeWidth":"3","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 100C24 106.627 29.3726 112 36 112C42.6274 112 48 106.627 48 100C48 93.3726 42.6274 88 36 88V91C40.9706 91 45 95.0294 45 100C45 104.971 40.9706 109 36 109C31.0294 109 27 104.971 27 100H24Z","fill":"#D8D8D8","key":3})]);
}

ProgressIndicator.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = ProgressIndicator;

ProgressIndicator.default = ProgressIndicator;
